module.exports = __webpack_public_path__ + "static/media/rameshwor_aryal.be345521.jpg";